

import axios from "axios";
import { useMutation, useQueryClient } from "react-query";
import { LoginContext } from "contexts/LoginContext";
import { useContext } from "react";
import {configUrl} from "config.js";

export default function usePoolQuestionLockUnLock() {
  let queryClient = useQueryClient();

  const {user} = useContext(LoginContext)

  return useMutation(
    async ({ id, questionId, lock }) => {
      await axios.put(`${configUrl.AssessmentServer}/api/PoolQuestionMappings/lockUnlock/${id}/${questionId}/${lock}/${user}`);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("questionsByPoolId");
      },
    }
  );
}


